export const getGasResult = async () => {
  let res = await window.fetch('https://wallet-api.clover.finance/api/v2/feelevels')
  res = JSON.parse(await res.text())
  return {gasResult: res}
}
